<template lang="html">
    <div class="container container-medium mt-3 article reading">
            <p><b>Peaj</b> - înregistrarea în format electronic a tarifului de trecere;</p>

            <p><b>Trecere</b> - parcurgerea, o singura data, într-un sens, a unei distante de pe un sector de drum, pod, tunel sau trecatoare de munte, care face parte din reteaua de drumuri nationale din România, pe care se aplica tariful de trecere.</p>

            <p><b>Peaj valabil</b> reprezinta înregistrarea, în baza de date a SIEGMCR, a informatiilor privind achitarea corespunzatoare a tarifului de trecere pentru un vehicul, a carui perioada de valabilitate nu a expirat</p>

            <p>Conform <b>NORME METODOLOGICE din 28 aprilie 2015 pentru aplicarea de către Compania Naţională de Autostrăzi şi Drumuri Naţionale din România - S.A. a tarifului de utilizare şi a tarifului de trecere:</b></p>

            <p>Art. 7</p>

            <p>Tariful de trecere este structurat:</p>

            <ul>
                <li>a) pentru vehiculele de transport marfă cu MTMA mai mare sau egală cu 12 tone - în funcţie de numărul de axe şi de numărul de treceri;</li>
                <li>b) pentru vehiculele de transport marfă cu MTMA mai mică de 12 tone - în funcţie de MTMA şi de numărul de treceri;</li>
                <li>c) pentru vehiculele de transport persoane - în funcţie de numărul de locuri şi de numărul de treceri.</li>
            </ul>

            <p>Conform <b>ORDIN nr. 612 din 28 aprilie 2015 privind stabilirea tarifului de trecere înregistrat prin intermediul sistemului informatic de emitere, gestiune, monitorizare şi control al rovinietei</b></p>

            <p>ANEXĂ: TARIFE DE TRECERE pentru utilizarea podurilor peste Dunăre între Feteşti şi Cernavodă</p>

            <table class="table table-stripped">
                <tr>
                    <th></th>
                    <th>Tipul vehiculului</th>
                    <th>Numarul de treceri</th>
                    <th>Tariful - lei - (cu TVA inclus)</th>
                </tr>

                <tr>
                    <td rowspan="3">1</td>
                    <td rowspan="3">
                        <p>a) Vehicule rutiere de transport persoane cu cel mult 8 + 1 locuri pe scaune, inclusiv conducătorul auto - autoturisme</p>
                        <p>b) Vehicule rutiere cu masa totală maximă autorizată mai mică sau egală cu 3,5 tone, exclusiv vehiculele rutiere de transport persoane</p>
                    </td>
                    <td>1</td>
                    <td>13,00</td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>26,00</td>
                </tr>
                <tr>
                    <td>20</td>
                    <td>208,00</td>
                </tr>

                <tr>
                    <td rowspan="3">2</td>
                    <td rowspan="3">
                        <p>a) Vehicule rutiere de transport persoane cu mai mult de 9 locuri pe scaune, inclusiv conducătorul auto, şi maximum 23 de locuri pe scaune, inclusiv conducătorul auto</p>
                        <p>b) Vehicule rutiere cu masa totală maximă autorizată mai mare de 3,5 tone şi mai mică de 12,0 tone, exclusiv vehiculele rutiere de transport persoane</p>
                    </td>
                    <td>1</td>
                    <td>47,00</td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>94,00</td>
                </tr>
                <tr>
                    <td>20</td>
                    <td>818,00</td>
                </tr>

                <tr>
                    <td rowspan="3">3</td>
                    <td rowspan="3">
                        <p>a) Vehicule rutiere de transport persoane cu mai mult de 23 de locuri pe scaune (inclusiv conducătorul auto)</p>
                        <p>b) Vehicule rutiere cu masa totală maximă autorizată mai mare sau egală cu 12,0 tone şi cu maximum 3 axe (inclusiv), exclusiv vehiculele rutiere de transport persoane</p>
                    </td>
                    <td>1</td>
                    <td>64,00</td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>128,00</td>
                </tr>
                <tr>
                    <td>20</td>
                    <td>1.114,00</td>
                </tr>

                <tr>
                    <td rowspan="3">4</td>
                    <td rowspan="3">
                        <p>Vehicule rutiere cu masa totală maximă autorizată mai mare sau egală cu 12,0 tone şi cu minimum 4 axe (inclusiv), exclusiv vehiculele rutiere de transport persoane</p>
                    </td>
                    <td>1</td>
                    <td>91,00</td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>182,00</td>
                </tr>
                <tr>
                    <td>20</td>
                    <td>1.584,00</td>
                </tr>
            </table>

            <p>Confom <b>ORDONANŢĂ DE URGENŢĂ nr. 8 din 22 aprilie 2015 pentru modificarea şi completarea unor acte normative</b></p>

            <p>Fapta de a circula fara peaj valabil constituie contraventie si se sanctioneaza cu amenda.</p>

            <p>
                ANEXA nr. 2: Cuantumul amenzii contravenţionale aplicabile utilizatorilor în cazul lipsei peajului valabil<br/>
                (- Anexa nr. 4 la Ordonanţa Guvernului nr. 15/2002)
            </p>

            <table class="table table-stripped">
                <tr>
                    <th rowspan="2"></th>
                    <th rowspan="2">Tipul vehiculului</th>
                    <th colspan="2">Cuantumul amenzii contravenţionale (lei)</th>
                </tr>
                <tr>
                    <th>minim</th>
                    <th>maxim</th>
                </tr>
                <tr>
                    <td>1</td>
                    <td>
                        <p>a) Vehicule rutiere de transport persoane cu cel mult 8 + 1 locuri pe scaune, inclusiv conducătorul auto - autoturisme</p>

                        <p>b) Vehicule rutiere cu masa totală maximă autorizată mai mică sau egală cu 3,5 tone, exclusiv vehiculele rutiere de transport persoane</p>
                    </td>
                    <td>130</td>
                    <td>260</td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>
                        <p>a) Vehicule rutiere de transport persoane cu mai mult de 9 locuri pe scaune, inclusiv conducătorul auto, şi maximum 23 de locuri pe scaune, inclusiv conducătorul auto</p>

                        <p>b) Vehicule rutiere cu masa totală maximă autorizată mai mare de 3,5 tone şi mai mică de 12,0 tone, exclusiv vehiculele rutiere de transport persoane</p>
                    </td>
                    <td>470</td>
                    <td>940</td>
                </tr>
                <tr>
                    <td>3</td>
                    <td>
                        <p>a) Vehicule rutiere de transport persoane cu mai mult de 23 de locuri pe scaune (inclusiv conducătorul auto)</p>

                        <p>b) Vehicule rutiere cu masa totală maximă autorizată mai mare sau egală cu 12,0 tone şi cu maximum 3 axe (inclusiv), exclusiv vehiculele rutiere de transport persoane</p>
                    </td>
                    <td>640</td>
                    <td>1.280</td>
                </tr>
                <tr>
                    <td>4</td>
                    <td>
                        <p>Vehicule rutiere cu masa totală maximă autorizată mai mare sau egală cu 12,0 tone şi cu minimum 4 axe (inclusiv), exclusiv vehiculele rutiere de transport persoane</p>
                    </td>
                    <td>910</td>
                    <td>1.820</td>
                </tr>
            </table>
        </div>

</template>

<script>
    export default {
        name: 'AboutPeaj',
    }
</script>

<style lang="scss" scoped>
</style>
